import { AppDatabase } from "./AppDatabase";
import { isNullOrUndefined } from "util";
import { IDataStore, DatabaseKey } from "./IDataStore";
import { Observable, BehaviorSubject, Observer } from 'rxjs';
import { ICourse , IUser, IResult, IOrganisation } from "../model/ModelTypes";
/**
 * DataStore implementation.
 * 
 * For each DatabaseKey there is a cached behaviour subject which is used to 
 * update listeners whenever the value of this key is updated. 
 * 
 * Inspired by Room SQLLite ORM in Android.
 */
export class DataStore implements IDataStore {
    private db = new AppDatabase();
    private observablesCache: 
    BehaviorSubject<IUser | IUser[] | IResult[] | IOrganisation | ICourse[] | undefined>[] = [];
    getDocuments<T>(key: DatabaseKey): Observable<T> {
        return Observable.create( (observer: Observer<T>) => {
            
            this.db.pairs.get(key).then( (result) => {
                if (isNullOrUndefined(this.observablesCache[key])) {
                    if (isNullOrUndefined(result) || isNullOrUndefined(result.value)) {
                        this.observablesCache[key] = new BehaviorSubject<T|undefined>(undefined);
                    } else {
                        this.observablesCache[key] = new BehaviorSubject<T|undefined>(JSON.parse(result.value));
                    }
                } else {
                    if (isNullOrUndefined(result) || isNullOrUndefined(result.value)) {
                        this.observablesCache[key].next(undefined);
                    } else {
                        this.observablesCache[key].next(JSON.parse(result.value));
                    }
                }
                observer.next(this.observablesCache[key]);
            }).catch( (error) => {
                observer.error(error);                
            }).finally( () => {
                observer.complete();
            });
        });
        
    }

    insertDocument<T>(document: T, key: DatabaseKey): Observable<Observable<T>> {
       
        return Observable.create((observer: Observer<Observable<T>>) => {
            this.db.pairs.put({key: key,
                value: !isNullOrUndefined(document) ? JSON.stringify(document) : undefined}).then(value => {
               if (!isNullOrUndefined(this.observablesCache[key])) {
                   this.observablesCache[key].next(document);
               } else {
                   this.observablesCache[key] = new BehaviorSubject<T>(document);
               }
               observer.next(this.observablesCache[key]);
               observer.complete();
           }).catch(error => {
               observer.error(error);
           }).finally(() => {
            observer.complete();
           });
        });
    }

    clear(): Observable<boolean> {
        return Observable.create(
            (observer: Observer<boolean>) => {
                this.db.pairs.clear()
                .then(() => observer.next(true)).catch(error => observer.error(error));
            }
        );
    }    

}


// WEBPACK FOOTER //
// ./src/repository/DataStore.ts